import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = m[1];

    api.post("/auth/session", { session_id })
      .then(({ data }) => {
        // CRITICAL: sync AuthProvider state so AdminLayout doesn't redirect to /login
        setUser(data);
        // strip the hash
        window.history.replaceState(null, "", "/admin");
        if (data.is_admin) navigate("/admin", { replace: true });
        else navigate("/", { replace: true });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-callback">
      <p className="text-neutral-500 text-sm tracking-wider">Authenticating…</p>
    </div>
  );
}
